
import { Options, Vue } from 'vue-class-component';

@Options({
    props: {
        step: {
            type: Number,
            required: true,
        },
        isAccessible: {
            type: Boolean,
            required: true,
        },
        isCurrent: {
            type: Boolean,
            required:true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    components: {

    },
    emits: [
        'click',
    ],
    /*emits: {
        success: (value: any) => value === null || typeof value === 'string' || Array.isArray(value),
    },*/
})
export default class CheckoutSteps extends Vue {
    step!: number
    isAccessible!: boolean
    isCurrent!: boolean
    title!: string

    get classes() {
        return {
            'checkout-steps-nav__entry--inaccessible': !this.isAccessible,
            'checkout-steps-nav__entry--current': this.isCurrent,
        };
    }

    mounted() {
        //
    }
}
